'<template>
   <div class="list_right" v-loading="loading">
      <template v-if="list.length > 0">
         <ul class="right_list">
            <li v-for="(item,index) in list">
               <router-link :to="'/user/message/info/'+item.code">
                  <h5 class="l_title">{{item.title}}</h5>
                  <span class="l_date">{{(item.createTime).slice(0,10)}}</span>
               </router-link>
            </li>
         </ul>

         <div class="list_pages">
            <el-pagination layout="prev, pager, next" :page-size="pageSize" :total="pagecount" @current-change="handleCurrentChange">
            </el-pagination>
         </div>
      </template>
      <el-empty description="暂无内容" v-else></el-empty>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'user_message_page',
      components: {},
      data() {
         return {
            loading: true,
            typeCode: 'qQZNNf', ///通知code

            pageNum: 1,
            pageSize: 10,
            pagecount: 10,
            list: [],
         };
      },
      watch: {
         $route() {

         },
      },
      mounted() {
         this.getlist();
      },
      methods: {
         getlist() {
            var _this = this;
            _this.loading = true;
            _this.$api.artList({
               categoryCode: _this.typeCode,
               pageNum: _this.pageNum,
               pageSize: _this.pageSize
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.list = res.data.list;
                  _this.pagecount = res.data.total;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         handleCurrentChange(val) {
            this.pageNum = val;
            this.getlist();
         }
      }
   }
</script>
<style lang="less" scoped>

</style>
